/**
 * Преобразует картинку file к новому размеру и типу.
 *
 * @param file      объект типа File
 * @param minSize   минимальный размер стороны новой картинки
 * @param imageType тип картинки, к которому преобразовать: png, jpeg
 * @returns {Promise<string>} содержимое нового файла в BASE64
 */
export function getThumbnail(file, minSize, imageType = 'png') {
    return new Promise((success, fail) => {
        if (!file) {
            return fail(new Error('Пустой файл.'));
        }
        if (!file.type || !file.type.startsWith('image/')) {
            return fail(new Error('Это не картинка'));
        }
        const canvas = document.createElement('canvas');
        canvas.width = minSize;
        canvas.height = minSize;
        const context = canvas.getContext('2d');
        const img = new Image();
        img.onload = () => {
            if (img.width > img.height) {
                canvas.width = minSize;
                canvas.height = (minSize * img.height) / img.width;
            } else {
                canvas.width = (minSize * img.width) / img.height;
                canvas.height = minSize;
            }
            context.drawImage(img, 0, 0, canvas.width, canvas.height);
            const dataUrl = canvas.toDataURL('image/' + imageType);
            const base64Content = dataUrl.split(',')[1];
            //const byteString = atob(base64Content);
            //const ab = new ArrayBuffer(byteString.length);
            //const ia = new Uint8Array(ab);
            //for (let i = 0; i < byteString.length; i++) {
            //    ia[i] = byteString.charCodeAt(i);
            //}
            //success(new File([ab], file.name + '.' + imageType, { type: 'image/' + imageType }));
            success(base64Content);
        };
        img.onerror = fail;
        img.src = URL.createObjectURL(file);
    });
}
